import React, { FC } from 'react';
import Table from 'antd/lib/table';
import Pagination from '../Pagination';
import Props from './typing';
import './style.scss';
import { useMemo } from 'react';

const sortMapping = {
  ascend: 'ASC',
  descend: 'DESC',
};

const reverseSortMapping = {
  ASC: 'ascend',
  DESC: 'descend',
};

const CustomTable: FC<Props> = (props): JSX.Element => {
  const {
    dataSource,
    handleSorting,
    totalRecords,
    showPagination,
    currentPage,
    onPageChangeHandler,
    rowKey,
    emptyTable,
    showPluralLogo,
    expandableConfig,
    rowClassName,
    yScroll,
    pageSize = 10,
    showPageSizeChanger,
    pageSizeOptions,
    onPageSizeChangeHandler,
    onRow,
    showSizeChanger,
  } = props;

  const columns = useMemo(() => {
    if (props.isSortingTwoWayBinded) {
      return props.columns
      .filter((item) => item.isColumnVisible)
      .map((item) => {
        if (props.sortBy === item.key && props.orderBy) {
          return { ...item, sortOrder: reverseSortMapping[props.orderBy] };
        }
        return { ...item, sortOrder: false };
      });
    }
    return props.columns.filter((item) => item.isColumnVisible);
  }, [props.columns, props.sortBy, props.orderBy]);

  return (
    <React.Fragment>
      <Table
        tableLayout={'auto'}
        dataSource={dataSource}
        columns={columns}
        onChange={(pagination, filters, sorter) => {
          if (handleSorting) {
            handleSorting({
              columnName: sorter['columnKey'],
              order: sorter['order'] ? sortMapping[sorter['order']] : null,
            });
          }
        }}
        pagination={false}
        scroll={{ x: true, y: yScroll }}
        rowKey={rowKey}
        locale={{emptyText: emptyTable}}
        {...(expandableConfig && {
          expandable: {
            ...expandableConfig,
            expandedRowKeys: expandableConfig.expandedRowKeys,
            // Ant Design v4.x (currently antd@4.15.0) uses -1 to hide the dedicated expand icon column.
            ...(expandableConfig.showExpandColumn === false
              ? { expandIconColumnIndex: -1 }
              : {}),
          },
        })}
        rowClassName={rowClassName}
        onRow={onRow}
      />
      {showPagination && (
        <Pagination
          currentPage={currentPage}
          onPageChange={onPageChangeHandler}
          total={totalRecords}
          pageSize={pageSize}
          showSizeChanger={showSizeChanger ?? showPageSizeChanger ?? false}
          pageSizeOptions={pageSizeOptions}
          onPageSizeChange={onPageSizeChangeHandler}
          showPluralLogo={showPluralLogo}
        />
      )}
    </React.Fragment>
  );
};

export default CustomTable;
